import { Component } from '@angular/core';
import { BaseComponent } from '../../../../../base/base.component';

@Component({
  selector: 'app-wiki-table-bottom-toolbar',
  templateUrl: './wiki-table-bottom-toolbar.component.html',
  styleUrl: './wiki-table-bottom-toolbar.component.scss',
  standalone: false,
})
export class WikiTableBottomToolbarComponent extends BaseComponent {}
